/**
 * @file
 * Behaviors for oldie.theme.
 */

'use strict';

/**
 * Oldie namespace.
 */
Drupal.oldie = Drupal.oldie  || {};

/**
 * Window location information.
 *
 * @type {{path: String, host: String, href: String}}
 *
 * @private
 */
Drupal.oldie._windowLocation = {
  initialized: false,
  href: null,
  host: null,
  path: null,
  search: null,
};

Drupal.oldie.windowLocation = function() {
  if (Drupal.oldie._windowLocation.initialized) {
    return Drupal.oldie._windowLocation;
  }

  let host = window.location.protocol + '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '') + '/';

  Drupal.oldie._windowLocation.initialized = true;
  Drupal.oldie._windowLocation.href = window.location.href;
  Drupal.oldie._windowLocation.host = host;
  Drupal.oldie._windowLocation.search = window.location.search;
  Drupal.oldie._windowLocation.path = window.location.pathname;

  return Drupal.oldie._windowLocation;
};

/**
 * General link behaviors.
 *
 * Adds class "is-active" to active links.
 * Adds class "is-external" to external links.
 * Adds class "is-new-tab" to target _blank links.
 *
 * @type {Drupal~behavior}
 */
Drupal.behaviors.oldie_links = {
  /**
   * Initializes behaviors for a single link.
   *
   * @param elem An A element.
   */
  initAnchor(elem) {
    if (elem._oldieLink) {
      return;
    }

    elem._oldieLink = true;
    let wLoc = Drupal.oldie.windowLocation();

    // Ignore anchors linking to nothing.
    if (elem.href === '') {
      return;
    }

    // Mark the anchor as active, if applicable.
    if (elem.href == wLoc.href) {
      elem.classList.add('is-active');
    }

    // Mark the anchor as external, if applicable.
    if (
      elem.href.indexOf(wLoc.host) !== 0 &&
      !elem.href.match(/^(tel|mailto)\:/)
    ) {
      elem.classList.add('is-external');

      // Add visually hidden text for accessibility.
      if (elem.querySelector('img') === null) {
        elem.setAttribute('target', '_blank');
        elem.setAttribute('rel', 'noopener');

        let icon = document.createElement('span');
        icon.classList.add('icon', 'icon-link-ext');

        elem.append(icon);
      }
    }

    // Mark the anchor as new window, if applicable.
    if (elem.target === '_blank') {
      elem.classList.add('is-new-tab');
    }

    // Mark the anchor as aria-hidden.
    if (elem.getAttribute('rel') === 'hidden') {
      elem.setAttribute('aria-hidden', 'true');
    }

    // Determine if the link is a hash link.
    let isHash = false;
    if (elem.href.indexOf(wLoc.path + '#') === 0) {
      isHash = true;
    }
    if (elem.getAttribute('href').indexOf('#') === 0) {
      isHash = true;
    }

    // Mark the anchor as a hash link..
    if (isHash) {
      elem.classList.add('is-hash');
    }
  },
  attach() {
    document.querySelectorAll('a')
      .forEach(Drupal.behaviors.oldie_links.initAnchor);
  }
};

/**
 * Tooltips.
 *
 * @type {Drupal~behavior}
 */
Drupal.behaviors.oldie_tooltip = {
  attach() {
    document
      .querySelector('.layout-container')
      .querySelectorAll('a[title], abbr[title], time[title]')
      .forEach((elem) => {
        if (elem._oldieTooltip || elem.getAttribute('title') === '') {
          return;
        }

        elem.dataset.title = elem.getAttribute('title');
        elem.removeAttribute('title');

        elem._oldieTooltip =
          new Tooltip({
            target: elem,
            content: elem.dataset.title,
            classes: 'tooltip-theme-arrows',
            position: 'top center'
          });
      });
  }
};
